import { Typography, Grid } from '@mui/material';
import SubscribeSection from '../../../UI/SubscribeSection/SubscribeSection';

const HeroBanner = () => {
  return (
    <Grid
      container
      spacing={{ xs: 4, lg: 2 }}
      alignItems='center'
      sx={{ pt: { xs: '3rem', lg: '0rem' } }}
      justifyContent='center'>
      <Grid item lg={6}>
        <Typography variant='h3' component='h1' sx={{ fontWeight: 'bold' }}>
          Event Calendar
        </Typography>
        <Typography variant='body1' sx={{ my: '2rem' }}>
          View all past and upcoming events below. As always, members of The 100 Club attend all events free of charge.
        </Typography>
      </Grid>
      <SubscribeSection />
    </Grid>
  );
};

export default HeroBanner;
